<script>
  import {format, parse, isAfter, isSameDay} from 'date-fns';
  import Duracion from "../UI/Duracion.svelte";
  import Boton from "../UI/Boton.svelte";
  import Advertencia from "../UI/Advertencia.svelte";
  import {url} from '@sveltech/routify';
  import {nombreCompleto, horasTrabajadas} from '../../Modelos/Trabajador';

  import Diferencia from "../UI/Diferencia.svelte";

  import storeTrabajadores from '../../Stores/trabajadores-store';
  import storeTipos from '../../Stores/tipos-de-jornada-store';
  import storeTiposDeIncidencia from '../../Stores/tipos-de-incidencia-store';
  import Horas from "./Horas.svelte";
  import Incidencias from "./Incidencias.svelte";
  import Icono from "../UI/Icono.svelte";

  export let marcaje;
  export let trabajador = null;

  let previsto, diferencia, entradas, salidas, incorrecta, tipo, tipos, trabajadores,
      fecha, cargando, horas, futuro, tiposRepetidos, tiposDeIncidencia, aviso;

  const ahora = new Date();

  $: trabajadores = $storeTrabajadores.listadoIndexado;
  $: tipos = $storeTipos.listadoIndexado;
  $: tiposDeIncidencia = $storeTiposDeIncidencia.listadoIndexado

  $: if (Object.keys(trabajadores).length && Object.keys(tipos).length) {
    cargando = false;
    tipo = tipos[marcaje.tipo];
    previsto = (tipo && tipo.duracion) || 0;
    horas = marcaje.horas;
    const t = horas.reduce((acc, hora) => acc + (hora.motivo.tipo === 'Actividad' ? '1' : '0'), '');
    tiposRepetidos = t.indexOf('11') >= 0 || t.indexOf('00') > 0;

    entradas = horas.filter(x => x.motivo.tipo === 'Actividad').length;
    salidas = horas.filter(x => x.motivo.tipo === 'Ausencia').length;
    fecha = parse(marcaje.dia, 'yyyy-MM-dd', new Date());
    futuro = isAfter(fecha, ahora);
    incorrecta = tiposRepetidos || marcaje.incidencias.length;
    trabajador = trabajadores[marcaje.trabajador];
    aviso = horas.filter(x => x.observaciones).length > 0;
  } else {
    cargando = true;
    previsto = entradas = salidas = 0;
    incorrecta = false;
  }
</script>

<style>
    tr {
        --color-linea: var(--naranja-clarito);
        font-family: var(--familia-monoespaciada);
    }

    td {
        vertical-align: middle;
    }

    .sin-datos {
        background: var(--naranja-clarito);
        --color-linea: #fff;
    }

    .fecha {
        white-space: nowrap;
        display: flex;
        align-items: center;
        --color-icono: red;
    }

    .incorrecta {
        font-weight: bold;
    }

    .marcaje {
        margin: .25em;
        display: inline-block;
    }
</style>

{#if !cargando}
    <tr class:sin-datos={previsto === 0} class:incorrecta>
        <td>
            <div class="fecha">
                {format(fecha, 'dd/MM/yyyy')}
                {#if incorrecta}
                    <Advertencia>Día con errores</Advertencia>
                {/if}
            </div>
        </td>
        <td class="trabajador">
            {nombreCompleto(trabajador)}
        </td>
        <td>
            {#if !previsto}
                {tipo ? tipo.nombre : 'Sin tipo'}
            {:else}
                {#if aviso}
                    <Icono tamano="mediano" tipo="iconos" svg="hand-paper.svg"/>
                {/if}
                {#each horas as marcaje}
                    <Horas {marcaje}/>
                {/each}
                {#if marcaje.incidencias.length}
                    {#if horas.length}<br>{/if}
                    Incidencias: <Incidencias {marcaje} />
                {/if}
            {/if}
        </td>

        <td>
            {#if marcaje.horas.length}
                {marcaje.horas[0].origen}
            {/if}
        </td>

        {#if previsto === 0 && marcaje.tiempoTotal === 0}
            <td colspan="4"></td>
        {:else}
            <td>
                <Duracion minutos={previsto}/>
            </td>
            {#if futuro}
                <td colspan="3"></td>
            {:else}
                <td>
                    <Duracion minutos={marcaje.tiempoTotal}/>
                </td>
                <td>
                    <Diferencia {previsto} trabajado={marcaje.tiempoTotal}/>
                </td>
                <td>
                    <Boton tipo="ok" icono="keyboard_arrow_right"
                           href="{$url(`/trabajadores/${marcaje.trabajador}/marcajes/${format(fecha, 'dd-MM-yyyy')}`)}">
                        Ver&nbsp;detalles
                    </Boton>
                </td>
            {/if}
        {/if}
    </tr>
{/if}